import { useState } from "react";

import { Room, RoomInfo, UserInfo, IError } from "../types";

export interface CreateRoomForm {
  roomName: string | undefined;
  // roomNumber: string | undefined;
}

export interface JoinRoomForm {
  roomId: string | undefined;
  username: string | undefined;
}

export interface RoomsService {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  isLoadingAll: boolean;
  setIsLoadingAll: (isLoadingAll: boolean) => void;
  isSendRematchInvitationLoading: boolean;
  hasPendingRematchInvitation: boolean;
  setHasPendingRematchInvitation: (hasIt: boolean) => void;
  setIsSendRematchInvitationLoading: (isLoading: boolean) => void;
  rooms: Room[];
  setRooms: (rooms: Room[]) => void;
  allRooms: RoomInfo[];
  setAllRooms: (allRooms: RoomInfo[]) => void;
  allUsers: UserInfo[];
  setAllUsers: (allUsers: UserInfo[]) => void;
  createRoomForm: CreateRoomForm;
  joinRoomForm: JoinRoomForm;
  isCreatingRoom: boolean;
  isJoiningRoom: boolean;
  error: IError | undefined;
  setError: (error: IError | undefined) => void;
  updateCreateRoomForm: (form: CreateRoomForm) => void;
  updateJoinRoomForm: (form: JoinRoomForm) => void;
  setIsJoiningRoom: (isJoiningRoom: boolean) => void;
  setIsCreatingRoom: (isCreatingRoom: boolean) => void;
  initCreateForm: () => void;
  initJoinForm: () => void;
}

interface Params {}

const initCreateRoomForm = () => ({
  roomName: undefined
  // roomNumber: undefined
});

const initJoinRoomForm = () => ({
  roomId: undefined,
  username: undefined,
});

const useRoomsService = (params: Params): RoomsService => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingAll, setIsLoadingAll] = useState<boolean>(false);
  const [isSendRematchInvitationLoading, setIsSendRematchInvitationLoading] =
    useState<boolean>(false);

  const [hasPendingRematchInvitation, setHasPendingRematchInvitation] =
    useState<boolean>(false);

  const [rooms, setRooms] = useState<Room[]>([]);
  const [allRooms, setAllRooms] = useState<RoomInfo[]>([]);
  const [allUsers, setAllUsers] = useState<UserInfo[]>([]);
  const [isCreatingRoom, setIsCreatingRoom] = useState<boolean>(false);
  const [isJoiningRoom, setIsJoiningRoom] = useState<boolean>(false);

  const [createRoomForm, updateCreateRoomForm] = useState<CreateRoomForm>(
    initCreateRoomForm()
  );

  const [joinRoomForm, updateJoinRoomForm] = useState<JoinRoomForm>(
    initJoinRoomForm()
  );

  const [error, setError] = useState<IError | undefined>(undefined);

  const initCreateForm = () => {
    updateCreateRoomForm(initCreateRoomForm());
  };

  const initJoinForm = () => {
    updateJoinRoomForm(initJoinRoomForm());
  };

  return {
    isLoading,
    setIsLoading,
    rooms,
    setRooms,
    isLoadingAll,
    setIsLoadingAll,
    allRooms,
    setAllRooms,
    allUsers,
    setAllUsers,
    createRoomForm,
    isCreatingRoom,
    setIsCreatingRoom,
    updateCreateRoomForm,
    initCreateForm,
    isJoiningRoom,
    setIsJoiningRoom,
    updateJoinRoomForm,
    joinRoomForm,
    initJoinForm,
    error,
    setError,
    isSendRematchInvitationLoading,
    setIsSendRematchInvitationLoading,
    hasPendingRematchInvitation,
    setHasPendingRematchInvitation,
  };
};

export default useRoomsService;
